module.exports = __webpack_public_path__ + "img/mypage.fc520901.png";